// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        numberFilterTree: 2
    },
    search: {		
      	showSuggestionProductPrice: false,
      	showSuggestionProductSalePrice: false,
    }
};

var bcSfFilterTemplate = {
    'saleClass': 'on-sale',
    'soldOutClass': 'sold-out',
    'blockLayoutClass': 'ft ftw ft-nm',

    'saleLabelHtml': '<span class="product-label sale"><span>' + bcSfFilterConfig.label.sale + '</span></span>',
    'soldOutLabelHtml': '<span class="product-label soldout"><span>' + bcSfFilterConfig.label.soldout + '</span></span>',

    // Grid Template
    'productGridItemHtml':  '<div class="product-block {{soldOutClass}} flex column {{maxColsClass}} min-cols-2 {{itemGridWidthClass}}">' +
                                '<div class="image">' +
                                    '<div class="inner">' +
                                        '<a href="{{itemUrl}}">' +
                                            '<img src="{{itemThumbUrl}}" {{itemImageSrcSet}} alt="{{itemTitle}}" />' +
                                        '</a>' +
                                        '{{itemQuickView}}' +
                                    '</div>' +
                                    '{{itemLabels}}' +
                                '</div>' +

                                '<div class="{{blockLayoutClass}}">' +
                                    '<div class="ftr">' +
                                        '<a class="title ftc" href="{{itemUrl}}">{{itemTitle}}</a>' +
  										'<div class="price ftc {{saleClass}}" style="display: none">{{itemPrice}}</div>' +
                                    '</div>' +
                                '</div>' +

                                '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}" class="prev"><i class="icon-arrow-left"></i></a></li>',
    'previousDisabledHtml': '<li><span class="linkless prev"><i class="icon-arrow-left"></i></span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}" class="next"><i class="icon-arrow-right"></i></a></li>',
    'nextDisabledHtml': '<li><span class="linkless next"><i class="icon-arrow-right"></i></span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span class="linkless">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span class="linkless">{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination">{{previous}}{{pageItems}}{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + ':</label><div class="pretty-select id-sort-by"><select id="sort-by" class="sort-by">{{sortingItems}}</select><span class="text"><span class="value">{{itemLabelActive}}</span></span><i class="icon-arrow3-down"></i></div>',
};

BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add soldOut class
    var soldOutClass = soldOut && bcSfFilterConfig.custom.label_soldout_enable ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add maxColsClass
    itemHtml = itemHtml.replace(/{{maxColsClass}}/g, 'max-cols-' + bcSfFilterConfig.custom.products_per_row);

    // Add itemGridWidthClass
    var itemGridWidthClass = ''
    if (index % 2 == 1) { itemGridWidthClass += 'nth-2 '; }
    if (index % 3 == 1) { itemGridWidthClass += 'nth-3 '; }
    if (index % 4 == 1) { itemGridWidthClass += 'nth-4 '; }
    if (index % 6 == 1) { itemGridWidthClass += 'nth-6 '; }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    // Add Block layout class
    var blockLayoutClass = bcSfFilterConfig.custom.block_layout == 'beside' ? bcSfFilterTemplate.blockLayoutClass : '';
    itemHtml = itemHtml.replace(/{{blockLayoutClass}}/g, blockLayoutClass);

    // Add price
    var itemPriceHtml = '';
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    if (priceVaries) {
        itemPriceHtml += bcSfFilterConfig.label.from_price + ' ';
    }
    itemPriceHtml += '<span class="amount">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    if (onSale) {
        itemPriceHtml += ' <del>' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</del>';
    }
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Labels
    var itemLabelsHtml = '';
    if (onSale && bcSfFilterConfig.custom.label_sale_enable) {
        itemLabelsHtml += bcSfFilterTemplate.saleLabelHtml;
    } else if (bcSfFilterConfig.custom.label_remain_show && data.variants.length == 1 && data['variants'][0].length  > 0 && data['variants'][0].inventory_quantity > 0 && data['variants'][0].inventory_quantity < bcSfFilterConfig.custom.prod_stock_warn_limit) {
        itemLabelsHtml += '<span class="product-label general"><span>' + bcSfFilterConfig.label.only_x_left.replace(/{{ quantiy }}/g, data['variants'][0]['inventory_quantity']) + '</span></span>';
    } else {
        if (soldOut && bcSfFilterConfig.custom.label_soldout_enable) {
            itemLabelsHtml += bcSfFilterTemplate.soldOutLabelHtml;
        } else {
            for (var k in data.tags) {
                var tag = data['tags'][k];
                if (tag.indexOf('meta-label-') > -1) {
                    itemLabelsHtml += '<span class="product-label general"><span>' + tag.replace('meta-label-', '') + '</span></span>';
                }
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Thumb source
    var imageSrcSet = ' srcset=" ' + this.getFeaturedImage(images, '150x') + ' 150w,';
    imageSrcSet += this.getFeaturedImage(images, '300x') + ' 300w,';
    imageSrcSet += this.getFeaturedImage(images, '600x') + ' 600w,';
    imageSrcSet += this.getFeaturedImage(images, '800x') + ' 800w,';
    imageSrcSet += this.getFeaturedImage(images, '1000x') + ' 1000w"';
    imageSrcSet += 'sizes="(max-width: 767px) 50vw, ' + 100 / bcSfFilterConfig.custom.products_per_row + ' vw';
    itemHtml = itemHtml.replace(/{{itemImageSrcSet}}/g, imageSrcSet);

    // Add Quickview
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.prod_quick_buy_show) {
        itemQuickViewHtml += '<div class="quick-buy-wrap pos-' + bcSfFilterConfig.custom.prod_quick_buy_pos + '">';
        itemQuickViewHtml += '<a class="quick-buy ';
        itemQuickViewHtml += bcSfFilterConfig.custom.prod_quick_buy_pos == 'middle' ? 'giant' : 'big';
        itemQuickViewHtml += '-round-button" href="{{itemUrl}}">' + bcSfFilterConfig.label.quick_view + '</a>';
        itemQuickViewHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  
    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            html = html.replace(/{{itemLabelActive}}/g, sortingArr[this.queryParams.sort]);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function() {
    // Produdct Reviews
    window.innerShiv=function(){function t(t,e,i){return/^(?:area|br|col|embed|hr|img|input|link|meta|param)$/i.test(i)?t:e+"></"+i+">"}var e,i,n=document,a="abbr article aside audio canvas datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video".split(" ");return function(r,o){if(!e&&(e=n.createElement("div"),e.innerHTML="<nav></nav>",i=1!==e.childNodes.length)){for(var s=n.createDocumentFragment(),d=a.length;d--;)s.createElement(a[d]);s.appendChild(e)}if(r=r.replace(/^\s\s*/,"").replace(/\s\s*$/,"").replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"").replace(/(<([\w:]+)[^>]*?)\/>/g,t),e.innerHTML=(s=r.match(/^<(tbody|tr|td|col|colgroup|thead|tfoot)/i))?"<table>"+r+"</table>":r,s=s?e.getElementsByTagName(s[1])[0].parentNode:e,o===!1)return s.childNodes;for(var d=n.createDocumentFragment(),l=s.childNodes.length;l--;)d.appendChild(s.firstChild);return d}}(),function(){window.SPR=function(){function t(){}return t.shop=Shopify.shop,t.host="//productreviews.shopifycdn.com",t.version="v4",t.api_url=t.host+"/proxy/"+t.version,t.asset_url=t.host+"/assets/"+t.version,t.badgeEls=[],t.reviewEls=[],t.elSettings={},t.$=void 0,t.extraAjaxParams={shop:t.shop},t.registerCallbacks=function(){return this.$(document).bind("spr:badge:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onBadgeLoad:void 0),this.$(document).bind("spr:product:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onProductLoad:void 0),this.$(document).bind("spr:reviews:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onReviewsLoad:void 0),this.$(document).bind("spr:form:loaded","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormLoad:void 0),this.$(document).bind("spr:form:success","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormSuccess:void 0),this.$(document).bind("spr:form:failure","undefined"!=typeof SPRCallbacks&&null!==SPRCallbacks?SPRCallbacks.onFormFailure:void 0)},t.loadStylesheet=function(){var t,e;return e=document.createElement("link"),e.setAttribute("rel","stylesheet"),e.setAttribute("type","text/css"),e.setAttribute("href",this.asset_url+"/spr.css"),e.setAttribute("media","screen"),t=document.getElementsByTagName("head")[0],t.appendChild(e)},t.initRatingHandler=function(){return t.$(document).on("mouseover mouseout","form a.spr-icon-star",function(e){var i,n,a;return i=e.currentTarget,a=t.$(i).attr("data-value"),n=t.$(i).parent(),"mouseover"===e.type?(n.find("a.spr-icon:lt("+a+")").addClass("spr-icon-star-hover"),n.find("a.spr-icon:gt("+(a-1)+")").removeClass("spr-icon-star-hover")):n.find("a.spr-icon").removeClass("spr-icon-star-hover")})},t.initDomEls=function(){return this.badgeEls=this.$(".shopify-product-reviews-badge[data-id]"),this.reviewEls=this.$("#shopify-product-reviews[data-id]"),this.$.each(this.reviewEls,function(t){return function(e,i){var n;return n=t.$(i).attr("data-id"),t.elSettings[n]={},t.elSettings[n].reviews_el="#"+(t.$(i).attr("data-reviews-prefix")?t.$(i).attr("data-reviews-prefix"):"reviews_"),t.elSettings[n].form_el="#"+(t.$(i).attr("data-form-prefix")?t.$(i).attr("data-form-prefix"):"form_")}}(this))},t.loadProducts=function(){return this.$.each(this.reviewEls,function(t){return function(e,i){var n,a,r;return a=t.$(i).attr("data-id"),n=t.$(i).attr("data-autoload"),"false"!==n?(r=t.$.extend({product_id:a,version:t.version},t.extraAjaxParams),t.$.get(t.api_url+"/reviews/product",r,t.productCallback,"jsonp")):void 0}}(this))},t.loadBadges=function(){var t,e,i,n,a;if(i=this.$.map(this.badgeEls,function(t){return function(e){return t.$(e).attr("data-id")}}(this)),i.length>0){for(e=7,a=[];(t=i.splice(0,e)).length>0;)n=this.$.extend(this.extraAjaxParams,{product_ids:t}),a.push(this.$.get(this.api_url+"/reviews/badges",n,this.badgesCallback,"jsonp"));return a}},t.pageReviews=function(t){var e,i,n;return n=this.$(t).data("product-id"),i=this.$(t).data("page"),e=this.$.extend({page:i,product_id:n},this.extraAjaxParams),this.$.get(this.api_url+"/reviews",e,this.paginateCallback,"jsonp"),!1},t.submitForm=function(t){var e;return e=this.$(t).serializeObject(),e=this.$.extend(e,this.extraAjaxParams),e=this.$.param(e),e=e.replace(/%0D%0A/g,"%0A"),this.$.ajax({url:this.api_url+"/reviews/create",type:"GET",dataType:"jsonp",data:e,success:this.formCallback,beforeSend:function(t){return function(){return t.$(".spr-button-primary").attr("disabled","disabled")}}(this),complete:function(t){return function(){return t.$(".spr-button-primary").removeAttr("disabled")}}(this)}),!1},t.reportReview=function(t){var e;return confirm("Are you sure you want to report this review as inappropriate?")&&(e=this.$.extend({id:t},this.extraAjaxParams),this.$.get(this.api_url+"/reviews/report",e,this.reportCallback,"jsonp")),!1},t.toggleReviews=function(t){var e;return e=this.$("#shopify-product-reviews[data-id='"+t+"']"),e.find(".spr-reviews").toggle()},t.toggleForm=function(t){var e;return e=this.$("#shopify-product-reviews[data-id='"+t+"']"),e.find(".spr-form").toggle()},t.setRating=function(t){var e,i,n;return e=this.$(t).parents("form"),n=this.$(t).attr("data-value"),i=this.$(t).parent(),e.find("input[name='review[rating]']").val(n),this.setStarRating(n,i)},t.setStarRating=function(t,e){return e.find("a:lt("+t+")").removeClass("spr-icon-star-empty spr-icon-star-hover"),e.find("a:gt("+(t-1)+")").removeClass("spr-icon-star-hover").addClass("spr-icon-star-empty")},t.badgesCallback=function(e){var i;return i=e.badges,t.$.map(t.badgeEls,function(e){var n;return n=t.$(e).attr("data-id"),void 0!==i[n]?(t.$(e).replaceWith(i[n]),t.$(document).trigger("spr:badge:loaded",{id:n})):void 0})},t.productCallback=function(e){var i;return i=e.remote_id.toString(),t.renderProduct(i,e.product),t.renderForm(i,e.form),t.renderReviews(i,e.reviews)},t.renderProduct=function(t,e){return this.$.map(this.reviewEls,function(i){return function(n){return t===i.$(n).attr("data-id")?(i.$(n).html(innerShiv(e,!1)),i.$(document).trigger("spr:product:loaded",{id:t})):void 0}}(this))},t.renderForm=function(t,e){var i;return i=this.$(this.elSettings[t].form_el+t),i.html(e),this.$(document).trigger("spr:form:loaded",{id:t})},t.renderReviews=function(e,i){var n;return n=t.$(t.elSettings[e].reviews_el+e),n.html(i),t.$(document).trigger("spr:reviews:loaded",{id:e})},t.formCallback=function(e){var i,n,a,r;return r=e.status,a=e.remote_id,n=e.form,i=t.$(t.elSettings[a].form_el+a),i.html(n),"failure"===r&&t.initStarRating(i),"success"===r&&t.$("#shopify-product-reviews[data-id='"+a+"'] .spr-summary-actions-newreview").hide(),t.$(document).trigger("spr:form:"+r,{id:a})},t.initStarRating=function(t){var e,i,n;return n=t.find("input[name='review[rating]']"),n&&n.val()?(i=n.val(),e=t.find(".spr-starrating"),this.setStarRating(i,e)):void 0},t.paginateCallback=function(e){var i,n;return n=e.remote_id.toString(),i=e.reviews,t.renderReviews(n,i)},t.reportCallback=function(e){var i;return i="#report_"+e.id,t.$(i).replaceWith("<span class='spr-review-reportreview'>"+t.$(i).attr("data-msg")+"</span>")},t.loadjQuery=function(e){return t.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js",function(){return t.$=jQuery.noConflict(!0),e()})},t.loadScript=function(t,e){var i;return i=document.createElement("script"),i.type="text/javascript",i.readyState?i.onreadystatechange=function(){return"loaded"===i.readyState||"complete"===i.readyState?(i.onreadystatechange=null,e()):void 0}:i.onload=function(){return e()},i.src=t,document.getElementsByTagName("head")[0].appendChild(i)},t.loadjQueryExtentions=function(t){return t.fn.serializeObject=function(){var e,i;return e={},i=this.serializeArray(),t.each(i,function(){return e[this.name]?(e[this.name].push||(e[this.name]=[e[this.name]]),e[this.name].push(this.value||"")):e[this.name]=this.value||""}),e}},t}(),function(){return SPR.loadStylesheet(),SPR.loadjQuery(function(){return SPR.$.ajaxSetup({cache:!1}),SPR.loadjQueryExtentions(SPR.$),SPR.$(document).ready(function(){return SPR.registerCallbacks(),SPR.initRatingHandler(),SPR.initDomEls(),SPR.loadProducts(),SPR.loadBadges()})})}()}.call(this);

    // Add content for Quick view
    jQ('.product-block').each(function() {
        var _this = this;
        var url = jQ(this).find("a").eq(0).attr("href");
        jQ.ajax({
            type: "GET",
            url: url + '?view=quickview',
            success: function(data){
                jQ(_this).append(data);
            }
        });
    })
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
    // Display number of products
    jQ('.results-count').html(bcSfFilterConfig.label.products_count.replace(/{{ count }}/g, data.total_product));
}

function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
